const translations = {
  invalid_credentials: 'Invalid credentials',
  server_error: 'There was an error',
  logout: 'Logout',
  logout_from_user: 'Logout from user',
  back: 'Back',
  select_account: 'Select Account',
  which_account_are_you_looking_for: 'Which account are you looking for?',
  which_user_are_you_looking_for: 'Which user are you looking for?',
  enter_username: 'Enter user name',
  input_username: 'This field is required',
  input_email: 'This field is required',
  enter_password: 'Enter password',
  input_password: 'This field is required',
  remember_me: 'Remember me',
  recover_password: 'Recover password',
  sign_in: 'Sign in',
  you_are_going_to_close: 'You are going to close the current session, continue?',
  not_admin_error: 'Access restricted',

  invalid_email: 'Invalid email address',
  recover_description: "Enter the email address associated with your account and we'll send you a link to reset your password.",
  email_placeholder: 'Enter email',
  back_to_login: 'Back to log in',
  recover_email_success: "We have sent you an email to reset the password",

  set_the_password: 'Set new password',
  set_password_description: 'Password must be at least 6 characters long and contain letters and numbers.',
  set_password_success: 'Password reset successfully',
  set_password_error: 'There was an error reseting the password',
  repeat_password: 'Repeat password',
  password_not_equals: 'Passwords must be equals',

  accept_beta_title: 'Welcome to the INV360 web app <strong><i>beta</i></strong> version',
  accept_beta_description: 'You are using a beta version of our app currently in development. Some features and elements may be unstable or not work as expected. We appreciate your understanding and invite you to explore it at your discretion. During this phase, your feedback is invaluable in helping us improve the experience and optimize the final version. If you encounter any issues or have suggestions, please don’t hesitate to share them with us.',
  accept_beta_terms: 'I understand and accept the terms of use'
}

export default translations;
